import axios from "axios";
import settings from "utils/settings";

const { apiUrl } = settings;

export const interviewCategoriesGet = (includeInactive = false) =>
	axios.get(`${apiUrl}ats/interview-categories?includeInactive=${!!includeInactive}`);

export const interviewCategoryGetById = (id) =>
	axios.get(`${apiUrl}ats/interview-categories/${id}`);

export const interviewCategoryCreate = (data) =>
	axios.post(`${apiUrl}ats/interview-categories`, data);

export const interviewCategoryUpdate = (id, data) =>
	axios.put(`${apiUrl}ats/interview-categories/${id}`, data);

export const interviewCategoryDelete = (id) =>
	axios.delete(`${apiUrl}ats/interview-categories/${id}`);
